import template from './news12List.html';
import controller from './news12List.controller';
import './news12List.scss';

export default {
  restrict: 'E',
  bindings: {
    btnClass: '@',
    items: '<',
    itemClickHandler: '<',
    nextComponentHandler: '<',
    prevComponentHandler: '<',
    changeHandler: '<',
    listId: '@',
    labelField: '@',
    itemsPerColumn: '@',
    itemsPerScroll: '@',
    showPagination: '@',
    upIsPrev: '@',
    downIsNext: '@',
    cancelAllDownKeyEvents: '@',
    cancelAllUpKeyEvents: '@',
    focusOnPopulateIx: '<',
    showIcon: '<',
    showArrows: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};



/** WEBPACK FOOTER **
 ** ./client/app/components/common/news12List/news12List.component.js
 **/